import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  Image,
  Alert,
  Modal
} from "react-native";
import { useSessionStore } from "../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../state/src/useSessionStore";
import { useApiWithLoading } from '../../../../hooks/useApiWithLoading';
import { postFeeLookup } from "../../../../services/common.service";
import { ProductType } from "../../../../view-models/productType";
// import { useGlobalError } from '../../../uiComponents/GlobalErrorProvider';
import { useGlobalError }  from '../../../uiComponents/GlobalErrorProvider';

// Icons
import BackIcon from "../../../../../../../assets/images/back_icon.png";
import HelpIcon from "../../../../../../../assets/images/Icon_help.png";
import CloseIcon from "../../../../../../../assets/images/Icon_close.png";
import { updateConsumerProfile, postTransactionToKiosk, postAuthConsumer } from "../../../../services/send.service";
import { validateConsumer } from "../../../../services/receive.service";
import { getFieldsForProductRequest } from "../../../../services/receive.service";
import { buildSendValidationRequestFromStore } from "../../../../helper/sendValidationHelper";
import { buildTransactionParametersFromStore } from "../../../../helper/transactionParameterHelper";


// Send flow step components
import ReceiverReferenceNumberStep from "./steps/ReceiverReferenceNumberStep";
// We are verifying senderPhone number currently
// import SenderPhoneVerifyStep from "./steps/SenderPhoneVerifyStep";
import ConfirmationStep from "../../common/steps/ConfirmationStep";
import EnterPhoneStep, { EnterPhoneStepHandle } from "../../common/steps/EnterPhoneStep";
import ReceiverIdentificationTypeStep from "./steps/ReceiverIdentificationTypeStep";
import ReceiverStateOfIdStep from "./steps/ReceiverStateOfIdStep";
import ReceiverIdentificationNumberStep from "./steps/ReceiverIdentificationNumberStep";
import ReceiverAddressStep from "./steps/ReceiverAddressStep";
import ReceiverDOBStep from "./steps/ReceiverDOBStep";
import HeadToCashierStep from "./steps/HeadToCashierStep";
import AdditionalReceiverInformationStep from "./steps/AdditionalReceiverInformationStep";

import { GffpHelper } from "../../../../helper/gffpHelper";
import { FieldsForProductInfo } from "../../../../view-models/FieldsForProductInfo";
import { logUpdateConsumerProfileDraft } from "../../../../helper/createProfileHelper";
import { SendMoneyPostUpdateConsumerProfileParameter } from "../../../../view-models/SendMoneyPostUpdateConsumerProfileParameter";
import { buildAuthConsumerPostParameter } from "../../../../helper/authConsumerHelper";
import { AuthConsumerInfo } from "../../../../view-models/AuthConsumerInfo";
import { postReferenceNumberSearch } from "../../../../services/receive.service";
import { TransactionStatus } from "../../../../view-models/TransactionStatus";
import ReceiveAmountStep from "./steps/ReceiveAmountStep";
import { ReferenceNumberInfo } from "../../../../view-models/ReferenceNumberInfo";
import { buildReceiveValidationRequestFromStore } from "../../../../helper/receiveValidationHelper";
import { RequiredFields } from "../../../../view-models/RequiredFields";

interface MainSendScreenProps {
  handleClose?: () => void;
}

const steps = [
  { key: "receiverReferenceNumber", title: "Confirm your PIN", component: ReceiverReferenceNumberStep },
  // Not verifying phone number temporarily
  // { key: "senderPhoneVerify", title: "Set PIN", component: SenderPhoneVerifyStep },
  { key: "receiveAmount", title: "Receive Amount", component: ReceiveAmountStep },
  { key: "tellUsAboutYouself", title: "Tell us about yourself", component: ConfirmationStep },
 
  { key: "receiverPhone", title: "Enter phone number", component: EnterPhoneStep },
  { key: "receiverIdentificationType", title: "Identification type", component: ReceiverIdentificationTypeStep },
  { key: "receiverIdNumber", title: "Your identification number", component: ReceiverIdentificationNumberStep },
  { key: "receiverstateOfId", title: "Choose State of ID", component: ReceiverStateOfIdStep },
  { key: "receiverAddress", title: "Your Address", component: ReceiverAddressStep },
  { key: "receiverDOB", title: "Your Date of Birth", component: ReceiverDOBStep },
  { key: "additionalReceiverInformation", title: "Additional Information", component: AdditionalReceiverInformationStep },
  { key: "receiverHeadToCashier", title: "Head to cashier", component: HeadToCashierStep },
];

export const MainReceiveScreen: React.FC<MainSendScreenProps> = ({
  handleClose
}) => {
  const { executeWithLoading } = useApiWithLoading();
  const { showError } = useGlobalError();
  const [currentStep, setCurrentStep] = useState(0);
  const [returnToStep, setReturnToStep] = useState<string | null>(null);
  const [isStepValid, setIsStepValid] = useState(false);
  const phoneStepRef = React.useRef<EnterPhoneStepHandle | null>(null);
  const isReceiver = useSessionStore((s: SessionState) => (s as any).isReceiver);
  const isSendCash = useSessionStore((s: SessionState) => (s as any).isSendCash);
  console.log('isSendCash==>', isSendCash, "isReceiver==>", isReceiver)
  const selectedDestinationCountryCode = useSessionStore((s: SessionState) => s.selectedDestinationCountryCode);
  const selectedDestinationStateAbbr = useSessionStore((s: SessionState) => s.selectedDestinationStateAbbr);
  const pendingSendOption = useSessionStore((s: SessionState) => (s as any).pendingSendOption);
  const selectedSendOptionValue = useSessionStore((s: SessionState) => (s as any).selectedSendOption);
  const setSelectedSendOption = useSessionStore((s: SessionState) => (s as any).setSelectedSendOption);
  const currentSendAmount = useSessionStore((s: SessionState) => (s as any).currentSendAmount);
  const agentId = useSessionStore((s: SessionState) => s.agentId);
  const unitProfileId = useSessionStore((s: SessionState) => s.unitProfileId);
  const selectedReceiveCurrency = useSessionStore((s: SessionState) => s.selectedReceiveCurrency);
  const setLastFeeLookupResponse = useSessionStore((s: SessionState) => (s as any).setLastFeeLookupResponse);
  const setGffpCategories = useSessionStore((s: SessionState) => (s as any).setGffpCategories);
  const setGffpFieldsByCategory = useSessionStore((s: SessionState) => (s as any).setGffpFieldsByCategory);
  const setMissingRequiredFields = useSessionStore((s: SessionState) => (s as any).setMissingRequiredFields);
  const selectedIdPhotoIdState = useSessionStore((s: SessionState) => (s as any).selectedIdPhotoIdState);
  const selectedIdPhotoIdCountry = useSessionStore((s: SessionState) => (s as any).selectedIdPhotoIdCountry);
  const recordStepTransition = useSessionStore((s: SessionState) => (s as any).recordStepTransition);
  const isNewConsumer = useSessionStore((s: SessionState) => (s as any).isNewConsumer);
  // Sender profile setters to hydrate from AuthConsumer
  const setConsumerId = useSessionStore((s: SessionState) => (s as any).setConsumerId);
  const setSenderFirstName = useSessionStore((s: SessionState) => (s as any).setSenderFirstName);
  const setSenderMiddleName = useSessionStore((s: SessionState) => (s as any).setSenderMiddleName);
  const setSenderLastName = useSessionStore((s: SessionState) => (s as any).setSenderLastName);
  const setSenderAddress = useSessionStore((s: SessionState) => (s as any).setSenderAddress);
  const setSenderCity = useSessionStore((s: SessionState) => (s as any).setSenderCity);
  const setSenderState = useSessionStore((s: SessionState) => (s as any).setSenderState);
  const setSenderZipCode = useSessionStore((s: SessionState) => (s as any).setSenderZipCode);
  const setSenderDOBString = useSessionStore((s: SessionState) => (s as any).setSenderDOBString);
  const setSenderDOB = useSessionStore((s: SessionState) => (s as any).setSenderDOB);
  const setPhoneNumber = useSessionStore((s: SessionState) => (s as any).setPhoneNumber);
  const setConfirmationNumber = useSessionStore((s: SessionState) => (s as any).setConfirmationNumber);
  const setReferenceNumberSearchResult = useSessionStore((s: SessionState) => (s as any).setReferenceNumberSearchResult);
 
  const consumerIdFromStore = useSessionStore((s: SessionState) => (s as any).consumerId);
  const StepComponent = steps[currentStep].component;
  const AnyStepComponent = StepComponent as any;
  const [rrnFieldLabel, setRrnFieldLabel] = useState<string | undefined>(undefined);
  const [referenceNumber, setReferenceNumber] = useState<string>("");
  const [showRefResultModal, setShowRefResultModal] = useState(false);
  const [refResult, setRefResult] = useState<{ receiverName?: string; senderName?: string; receiveAmount?: string | number; referenceNumber?: string | number } | null>(null);
  const receiverReceiveAmount = useSessionStore((s: SessionState) => (s as any).receiverReceiveAmount);
  const setReceiveAmountValidationError = useSessionStore((s: SessionState) => (s as any).setReceiveAmountValidationError);
  const referenceNumberSearchResult = useSessionStore((s: SessionState) => (s as any).referenceNumberSearchResult);

  // initialize timing for first step
  useEffect(() => {
    try { recordStepTransition?.(steps[0].key); } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Callback each step can use to report validity
  const handleValidationChange = (valid: boolean) => {
    setIsStepValid(valid);
  };

  const handleEditStep = (key: string) => {
    console.log('handleEditStep=>',key)
    const targetIndex = steps.findIndex(s => s.key === key);
    if (targetIndex !== -1) {
      console.log('setReturnToStep=>',steps[currentStep].key, 'targetIndex==>', targetIndex)
      setReturnToStep(steps[currentStep].key);   // "reviewAndEditStep"✅ remember where we came from
      setCurrentStep(targetIndex); // 7th index
    }
  };

  const handleNext = async (countryCode?: string) => {
    console.log('handleNext===>', handleNext);
    await executeWithLoading(async () => {
      // ---- normal forward navigation below ----
      if (steps[currentStep].key === "receiverReferenceNumber") {
        // Call reference number search before moving on
        const payload = await postReferenceNumberSearch({ 
          agentID: agentId,
          unitProfileID: unitProfileId,
          referenceNumber: referenceNumber });

        try {
         const rawData: ReferenceNumberInfo = (payload && (payload as any).data !== undefined) ? (payload as any).data : payload;
         let parsed: any = rawData;
         if (typeof rawData === 'string') {
           try { parsed = JSON.parse(rawData); } catch {}
         }
         try { setReferenceNumberSearchResult?.(parsed); } catch {}
         const errDetail = parsed?.ErrorDetail || parsed?.errorDetail;
         if (errDetail) {
           const errCode = errDetail?.ErrorCode ?? errDetail?.errorCode ?? 'UNKNOWN';
           const errString = errDetail?.ErrorString ?? errDetail?.errorString ?? 'An error occurred.';
           showError(errCode + ': ' + errString);
           return;
         }
        const receiverFirst = parsed?.ReceiverFirstName ?? parsed?.receiverFirstName ?? "";
        const receiverLast = parsed?.ReceiverLastName ?? parsed?.receiverLastName ?? "";
        const senderFirst = parsed?.SenderFirstName ?? parsed?.senderFirstName ?? "";
        const senderLast = parsed?.SenderLastName ?? parsed?.senderLastName ?? "";
        const receiveAmountVal = parsed?.ReceiveAmount ?? parsed?.receiveAmount ?? "";
        const referenceNumVal = parsed?.ReferenceNumber ?? parsed?.referenceNumber ?? "";
        setRefResult({
          receiverName: `${receiverFirst} ${receiverLast}`.trim(),
          senderName: `${senderFirst} ${senderLast}`.trim(),
          receiveAmount: receiveAmountVal,
          referenceNumber: referenceNumVal,
        });
     //   setShowRefResultModal(true);
      //  return;
        // TODO: Need to uncomment this below if
        /* if ((rawData?.errorDetail !== null &&
            rawData?.errorDetail?.errorCode !== undefined &&
            rawData?.errorDetail?.errorCode !== "") ||
            rawData?.TransactionStatus !== TransactionStatus.AVAIL || !rawData?.OkForAgent) {
              //showError(rawData?.errorDetail?.errorCode + ': ' + rawData?.errorDetail?.errorString);
              showError("your Transaction Refrence Number is not available. Please contact the sender");
        } */
        
        
          console.log('postReferenceNumberSearch result===', parsed);
        } catch (e) {
          console.warn('Reference number search failed', e);
          // optionally surface error via global handler
          try { showError?.(String((e as any)?.message || e)); } catch {}
        }
        const targetIndex = steps.findIndex(s => s.key === "receiveAmount");
        if (targetIndex !== -1) {
          setCurrentStep(targetIndex);
          return;
        }
      } else if (steps[currentStep].key === "receiveAmount") {
        // Compare entered amount with lookup result
        try {
          const expected = (refResult?.receiveAmount ?? (referenceNumber ? undefined : undefined));
          const expectedNum = Number(expected);
          const enteredNum = Number(receiverReceiveAmount || "0");
          if (!isNaN(expectedNum) && !isNaN(enteredNum)) {
            if (Number(expectedNum.toFixed ? expectedNum.toFixed(2) : expectedNum) !== Number(enteredNum.toFixed ? enteredNum.toFixed(2) : enteredNum)) {
              try { setReceiveAmountValidationError?.("Receive Amount Does not match"); } catch {}
              return; // stay on same screen
            }
          }
          try { setReceiveAmountValidationError?.(null); } catch {}
        } catch {}
        // On match: call getFieldsForProductRequest similar to send flow
        try {
          const r = referenceNumberSearchResult || {};
          const receiveCountry =  r.OriginatingCountry;
          const receiveCurrency = r?.ReceiveCurrency;
         // const receiveAgentID = (r?.ReceiveAgentID ?? r?.receiveAgentID ?? r?.receiveAgentId) || undefined;
          const amountNum = Number(String(receiverReceiveAmount || "0").replace(/,/g, ""));
          const payload: any = {
            unitProfileID: unitProfileId || "",
            agentID: agentId || "",
            receiveCountry,
            thirdPartyType: "NONE",
            receiveCurrency,
            amount: isFinite(amountNum) ? amountNum : 0,
            sendCurrency:  r.OriginalSendCurrency,
            productType: ProductType.RCV,
            CustomerId: "0",
          };
          const gffpResponse: FieldsForProductInfo = await getFieldsForProductRequest(payload);
          const requiredFields: any[] = GffpHelper.filterRequiredAndOptionalFields(gffpResponse) as any[];
          const groupedByCategory: Record<string, any[]> = requiredFields.reduce((acc: Record<string, any[]>, field: any) => {
            const category = field.FieldCategory ?? field.fieldCategory ?? 'Uncategorized';
            if (!acc[category]) acc[category] = [];
            acc[category].push(field);
            return acc;
          }, {});
          Object.keys(groupedByCategory).forEach((cat) => {
            groupedByCategory[cat].sort((a, b) => {
              const ao = a.DisplayOrder ?? a.displayOrder ?? 0;
              const bo = b.DisplayOrder ?? b.displayOrder ?? 0;
              return ao - bo;
            });
          });
          const distinctCategories = Object.keys(groupedByCategory);
          try { setGffpFieldsByCategory?.(groupedByCategory); } catch {}
          try { setGffpCategories?.(distinctCategories); } catch {}
        } catch (e) {
          console.warn('getFieldsForProductRequest (receive) failed', e);
        }
        const targetIndex = steps.findIndex(s => s.key === "tellUsAboutYouself");
        if (targetIndex !== -1) {
          setCurrentStep(targetIndex);
          return;
        }
      } else if (steps[currentStep].key === "tellUsAboutYouself") {
        console.log('CHECK INDEx key===', steps[currentStep].key)
        const targetIndex = steps.findIndex(s => s.key === "receiverPhone");
        if (targetIndex !== -1) {
          setCurrentStep(targetIndex);
          return;
        }
      } else if (steps[currentStep].key === "receiverPhone") {
        const targetIndex = steps.findIndex(s => s.key === "receiverIdentificationType");
        if (targetIndex !== -1) {
          setCurrentStep(targetIndex);
          return;
        }
      } else if (steps[currentStep].key === "receiverIdentificationType") {
        const targetIndex = steps.findIndex(s => s.key === "receiverIdNumber");
        if (targetIndex !== -1) {
          setCurrentStep(targetIndex);
          return;
        }
      } else if (steps[currentStep].key === "receiverIdNumber") {
        const targetIndex = steps.findIndex(s => s.key === "receiverstateOfId");
        if (targetIndex !== -1) {
          setCurrentStep(targetIndex);
          return;
        }
      } else if (steps[currentStep].key === "receiverstateOfId") {
        const targetIndex = steps.findIndex(s => s.key === "receiverAddress");
        if (targetIndex !== -1) {
          try { recordStepTransition?.("receiverAddress"); } catch {}
          setCurrentStep(targetIndex);
          return;
        }
      } else if (steps[currentStep].key === "receiverAddress") {
        const targetIndex = steps.findIndex(s => s.key === "receiverDOB");
        if (targetIndex !== -1) {
          try { recordStepTransition?.("receiverDOB"); } catch {}
          setCurrentStep(targetIndex);
          return;
        }
      } else if (steps[currentStep].key === "receiverDOB") {
        // After DOB, check for any missing required fields from GFFP
        try {
          const gffpFieldsByCategoryLocal = useSessionStore.getState().gffpFieldsByCategory || {};
          const validationReq = buildReceiveValidationRequestFromStore();
          const missing = new RequiredFields().getMissingFields(gffpFieldsByCategoryLocal, validationReq);
          if (missing && missing.length > 0) {
            try { setGffpFieldsByCategory?.(gffpFieldsByCategoryLocal); } catch {}
            try { setGffpCategories?.(Object.keys(gffpFieldsByCategoryLocal || {})); } catch {}
            try { setMissingRequiredFields?.(missing as any); } catch {}
            const aiIndex = steps.findIndex(s => s.key === "additionalReceiverInformation");
            if (aiIndex !== -1) {
              setCurrentStep(aiIndex);
              return;
            }
          }
          else {
            const result = await maultipleCalls();
          }
        } catch (e) {
          console.warn('Failed to compute missing fields after receiverDOB', e);
        }
        // No missing fields → proceed to HeadToCashier
        {
          const targetIndex = steps.findIndex(s => s.key === "receiverHeadToCashier");
          if (targetIndex !== -1) {
            try { recordStepTransition?.("receiverHeadToCashier"); } catch {}
            setCurrentStep(targetIndex);
            return;
          }
        }
      } else if (steps[currentStep].key === "receiverHeadToCashier") {
        
        // Build and log update consumer profile draft before proceeding
        const targetIndex = steps.findIndex(s => s.key === "fraudPrevention");
        if (targetIndex !== -1) {
          try { recordStepTransition?.("fraudPrevention"); } catch {}
          setCurrentStep(targetIndex);
          return;
        }
      }
      console.log("✅ Flow completed");
    }, 'Processing...');
  };

  const handleSkip = () => {
    // Run validation + transaction only, then jump to HeadToCashier
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    executeWithLoading(async () => {
      try {
        await maultipleCalls();
      } catch (e) {
        console.warn('Skip flow failed', e);
      }
      const targetIndex = steps.findIndex(s => s.key === "headToCashier");
      if (targetIndex !== -1) {
        try { recordStepTransition?.("headToCashier"); } catch {}
        setCurrentStep(targetIndex);
      }
    }, 'Processing...');
  };

  const maultipleCalls = async () => {

      try {
        const validationReq = buildReceiveValidationRequestFromStore();
        console.log("sendValidationRequest draft===", validationReq);
        const validationResponse = await validateConsumer(validationReq);
        console.log("validationResponse===", validationResponse);
        try {
          const ref = (validationResponse && ((validationResponse.confirmationNumber) || (validationResponse.ConfirmationNumber) || (validationResponse.referenceNumber) || (validationResponse.ReferenceNumber))) ?? undefined;
          if (ref) {
            try { setConfirmationNumber?.(String(ref)); } catch {}
          }
        } catch {}
        // Build transaction parameters and post to kiosk
        try {
          const txParams = buildTransactionParametersFromStore(validationResponse, 'receive');
          console.log('transactionParameters===', txParams);
          const txResp = await postTransactionToKiosk(txParams);
          console.log('postTransactionToKiosk response===', txResp);
        } catch (e) {
          console.warn('Failed to post transaction to kiosk', e);
        }
      } catch (e) {
        console.warn("Failed to build send validation request", e);
      }

    
  }

  // Enable Continue button for SendingAmountEntry step
  useEffect(() => {
    if (steps[currentStep].key === "sendingAmountEntry") {
      setIsStepValid(true);
    } else if (steps[currentStep].key !== "phone") {
      // Default allow for other non-phone steps unless they manage validation
      setIsStepValid(true);
    } else {
      // Phone step manages its own
      setIsStepValid(false);
    }
  }, [currentStep]);

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleCustomerNotFound = () => {
    const targetIndex = steps.findIndex(s => s.key === "country");
    if (targetIndex !== -1) {
      setCurrentStep(targetIndex);
    }
  };

  return (
  <SafeAreaView style={{ flex: 1, backgroundColor: "#FFF" }}>
    <KeyboardAvoidingView
      style={{ flex: 1 }}
      behavior={Platform.OS === "ios" ? "padding" : undefined}
      keyboardVerticalOffset={Platform.OS === "ios" ? 20 : 0}
    >
      <View style={styles.container}>
        {/* --- HEADER --- */}
        <View style={styles.header}>
          {/* Top Bar */}
          <View style={styles.topBar}>
            {(steps[currentStep].key !== "receiverReferenceNumber") ? (
              <TouchableOpacity style={styles.topBarButton} onPress={handleBack}>
                <Image source={BackIcon} style={styles.IconStyle} />
              </TouchableOpacity>
              ) : (
                <Text></Text>
              )
            }
            <View style={styles.topBarRight}>
              <TouchableOpacity style={styles.topBarButton}>
                <Image source={HelpIcon} style={styles.IconStyle} />
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.topBarButton}
                onPress={handleClose}
              >
                <Image
                  source={CloseIcon}
                  style={[styles.IconStyle, { marginLeft: 10 }]}
                />
              </TouchableOpacity>
            </View>
          </View>

          {/* Progress Bar */}
          <View style={styles.progressRow}>
            {steps.map((_, i) => (
              <View
                key={i}
                style={[
                  styles.progressSegment,
                  { backgroundColor: i <= currentStep ? "#000" : "#ccc" },
                ]}
              />
            ))}
          </View>
        </View>

        {/* --- STEP CONTENT --- */}
        <View style={styles.content}>
          <AnyStepComponent onValidationChange={handleValidationChange} onReferenceNumberChange={setReferenceNumber} />
        </View>
        {/* Modal for reference number result */}
        <Modal
          visible={showRefResultModal}
          transparent
          animationType="fade"
          onRequestClose={() => setShowRefResultModal(false)}
        >
          <View style={styles.modalOverlay}>
            <View style={styles.modalContainer}>
              <Text style={styles.modalTitle}>Transaction Details</Text>
              <View style={styles.modalDivider} />
              <View style={{ marginTop: 12 }}>
                <Text style={styles.modalRowLabel}>Receiver Name</Text>
                <Text style={styles.modalRowValue}>{refResult?.receiverName || '-'}</Text>
                <Text style={[styles.modalRowLabel, { marginTop: 8 }]}>Sender Name</Text>
                <Text style={styles.modalRowValue}>{refResult?.senderName || '-'}</Text>
                <Text style={[styles.modalRowLabel, { marginTop: 8 }]}>Receive Amount</Text>
                <Text style={styles.modalRowValue}>{String(refResult?.receiveAmount ?? '-')}</Text>
                <Text style={[styles.modalRowLabel, { marginTop: 8 }]}>Reference Number</Text>
                <Text style={styles.modalRowValue}>{String(refResult?.referenceNumber ?? '-')}</Text>
              </View>
              <TouchableOpacity style={[styles.button, { marginTop: 16 }]} onPress={() => setShowRefResultModal(false)}>
                <Text style={styles.buttonText}>OK</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
        {/* --- FIXED FOOTER --- */}
        <View style={styles.footer}>
            <TouchableOpacity
            style={[
              styles.button,
              { backgroundColor: isStepValid ? "#000" : "#999" },
            ]}
            onPress={() => handleNext()}
            disabled={!isStepValid}
          >
            <Text style={styles.buttonText}>
              {currentStep === steps.length - 1 ? "I’m finished" : "Continue"}
            </Text>
          </TouchableOpacity>
          {(steps[currentStep].key === "receiverReferenceNumber") && (
            <TouchableOpacity onPress={handleSkip} style={{ marginTop: 8, alignItems: "center" }}>
              <Text style={{ color: "#2563EB", textDecorationLine: "underline" }}>Disclaimer</Text>
            </TouchableOpacity>
          )}
        </View>
      </View>
    </KeyboardAvoidingView>
  </SafeAreaView>
);
}

const styles = StyleSheet.create({
    container: {
    flex: 1,
    width: "100%",
    backgroundColor: "#FFF",
  },
  header: {
    width: "100%",
    paddingHorizontal: 16
  },
  content: {
    flex: 1,
    width: "100%",
  },
  footer: {
    width: "100%",
    paddingHorizontal: 16,
    paddingBottom: Platform.OS === "ios" ? 24 : 16,
    backgroundColor: "#fff",   // keeps footer consistent
  },
  button: {
    width: "100%",             // button always full width
    backgroundColor: "#000",
    paddingVertical: 16,
    borderRadius: 8,
    alignItems: "center",
  },
  topBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 12
  },
  topBarButton: {
    padding: 1
  },
  topBarRight: {
    flexDirection: "row"
  },
  IconStyle: {
    height: 24,
    width: 24
  },
  iconText: {
    fontSize: 20,
    color: "#111"
  },
  progressRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 16,
    height: 6
  },
  progressSegment: {
    flex: 1,
    height: 6,
  },
  title: {
    fontSize: 20,
    fontWeight: "700",
    marginBottom: 16
  },
  buttonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600"
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center"
  },
  modalContainer: {
    width: "88%",
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: "700",
    textAlign: "center",
    marginBottom: 12
  },
  modalRowLabel: {
    fontSize: 14,
    color: "#555"
  },
  modalRowValue: {
    fontSize: 16,
    fontWeight: "600",
    color: "#111"
  },
  modalDivider: {
    height: 1,
    backgroundColor: "#E5E7EB",
    marginTop: 8
  },
});